import * as React from 'react';
import { Component } from 'react';
import { Field, Form, reduxForm } from 'redux-form';
import styles from '../../styles/forms/add_specification_wizard/AddSpecificationForm.scss';
import Button from '../../components/Button';
import { __, setTableParams } from '../../core/utils';
import Input from '../../components/Input';
import ButtonGroup from '../../components/ButtonGroup';
import autobind from 'autobind-decorator';
import RadioGroup from '../../components/RadioGroup';

@reduxForm({
  form: 'create_option_wizard.create_option',
})
class CreateOptionForm extends Component {
  @autobind
  _handleSubmit(edit) {
    this.props.change('edit', edit);

    setTimeout(() => this.props.submit(), 10);
  }

  render() {
    const { projectLanguage } = this.props;

    return (
      <Form onSubmit={this.props.handleSubmit} className={styles.wrapper}>
        {projectLanguage && (
          <Field
            name={'description.' + projectLanguage}
            component={Input}
            label={__(
              'working-set-specifications.basic-data-form.description'
            )}
            maxLength={70}
          />
        )}
        <div className={styles.exists}>Choose option type:</div>
        <Field
          name='action'
          component={RadioGroup}
          options={[
            {
              label: __('copy-specification-form.add-as-new-option.main'),
              value: 'option_main',
            },
            {
              label: __('copy-specification-form.add-as-new-option.alternative'),
              value: 'option_alternative',
            },
          ]}
        />
        <div className={styles.footer}>
          <Button
            lightGray
            medium
            left
            middleText={__('button.cancel')}
            onClick={() =>
              setTableParams('working_set_specifications', {
                create_option_wizard_active: undefined,
                create_option_source_specification: undefined,
              })
            }
          />
          <ButtonGroup>
            <Button
              lightBlue
              medium
              submit
              middleText='Create option'
              spinning={this.props.submitting}
              onClick={() => this._handleSubmit(false)}
            />
            <Button
              lightBlue
              medium
              submit
              middleText='Create option & Edit'
              spinning={this.props.submitting}
              onClick={() => this._handleSubmit(true)}
            />
          </ButtonGroup>
        </div>
      </Form>
    );
  }
}

export default CreateOptionForm;
